import { Injectable } from '@angular/core'
import { CalenModel } from './calen.model'
import { CmodalService } from '../cmodal/cmodal.service'

@Injectable({
  providedIn: 'root'
})
export class CalenService {
  components: any[]

  constructor(private cmodalService: CmodalService) {}

}
